import SuperbadgeIndexPage from "lx/superbadgeIndexPage";

export { SuperbadgeIndexPage };

customElements.define(
  "lx-superbadge-index-page",
  SuperbadgeIndexPage.CustomElementConstructor
);
